module.exports = __webpack_public_path__ + "static/media/icon-location.5bc4129b.svg";